// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-7b3d027a] {\n  /*50 = navbar  */\n  min-height: calc(100vh - 50px);\n  /* width: 100%; */\n  position: relative;\n  /* overflow: hidden; */\n  overflow: auto;\n  min-width: 900px;\n}\n.fixed-header+.app-main[data-v-7b3d027a] {\n  padding-top: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
